/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "common": {
        "nested": {
          "messages": {
            "nested": {
              "Empty": {
                "fields": {}
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.common?.nested?.messages?.nested?.Empty) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Empty @ squareup/common/messages.proto at 5:1
 */
export const Empty = $root.lookupType('squareup.common.messages.Empty');
fixType(Empty);
Builder.createAndAttachToType(Empty);